<template>
  <v-container fluid class="relative-prosition">
    <v-card>
      <v-card-title v-if="fullForm" class="py-2 blue">
        <div class="text-center width-100p">
          <div class="headline text-center blue">
            Clientes
          </div>
        </div>
      </v-card-title>
      <v-form :class="[fullForm ? 'layout row justify-center pa-3 pt-0' : '']">
        <v-container :class="[fullForm ? 'flex xs12 md11 lg10' : '']"
                     fluid
                     class="pa-0 relative-position"
        >
          <v-layout align-space-between justify-start row fill-height wrap>
            <v-flex :class="[fullForm ? 'py-1 xs12 sm6 md4 lg3' : 'py-1 xs12 md4']">
              <v-text-field
                v-model="cliente.Nombre"
                label="Nombre"
                class="mt-1"
                hide-details
              />
            </v-flex>
            <v-flex :class="[fullForm ? 'py-1 xs12 sm6 md4 lg3' : 'py-1 xs12 md4']">
              <v-text-field
                v-model="cliente.RazonSocial"
                label="Razon Social"
                class="mt-1"
                hide-details
              />
            </v-flex>
            <v-flex :class="[fullForm ? 'py-1 xs12 sm6 md4 lg3' : 'py-1 xs12 md4']">
              <v-text-field
                v-model="cliente.Cif"
                label="Cif"
                class="mt-1"
                hide-details
              />
            </v-flex>
            <v-flex :class="[fullForm ? 'py-1 xs12 sm6 md4 lg3' : 'py-1 xs12 md4']">
              <v-text-field
                v-model="cliente.Domicilio"
                label="Domicilio"
                class="mt-1"
                hide-details
              />
            </v-flex>
            <v-flex :class="[fullForm ? 'py-1 xs12 sm6 md4 lg3' : 'py-1 xs12 md4']">
              <v-text-field
                v-model="cliente.Poblacion"
                label="Poblacion"
                class="mt-1"
                hide-details
              />
            </v-flex>
            <v-flex :class="[fullForm ? 'py-1 xs12 sm6 md4 lg3' : 'py-1 xs12 md4']">
              <v-text-field
                v-model="cliente.CodigoPostal"
                label="Código postal"
                class="mt-1"
                hide-details
              />
            </v-flex>
            <v-flex :class="[fullForm ? 'py-1 xs12 sm6 md4 lg3' : 'py-1 xs12 md4']">
              <v-text-field
                v-model="cliente.Provincia"
                label="Provincia"
                class="mt-1"
                hide-details
              />
            </v-flex>
            <v-flex :class="[fullForm ? 'py-1 xs12 sm6 md4 lg3' : 'py-1 xs12 md4']">
              <v-text-field
                v-model="cliente.Pais"
                label="Pais"
                class="mt-1"
                hide-details
              />
            </v-flex>
            <v-flex :class="[fullForm ? 'py-1 xs12 sm6 md4 lg3' : 'py-1 xs12 md4']">
              <v-text-field
                v-model="cliente.Telefono1"
                label="Telefono1"
                class="mt-1"
                hide-details
              />
            </v-flex>
            <v-flex :class="[fullForm ? 'py-1 xs12 sm6 md4 lg3' : 'py-1 xs12 md4']">
              <v-text-field
                v-model="cliente.Telefono2"
                label="Telefono2"
                class="mt-1"
                hide-details
              />
            </v-flex>
            <v-flex :class="[fullForm ? 'py-1 xs12 sm6 md4 lg3' : 'py-1 xs12 md4']">
              <v-text-field
                v-model="cliente.Fax"
                label="Fax"
                class="mt-1"
                hide-details
              />
            </v-flex>
            <v-flex :class="[fullForm ? 'py-1 xs12 sm6 md4 lg3' : 'py-1 xs12 md4']">
              <v-text-field
                v-model="cliente.Email"
                label="Email"
                class="mt-1"
                hide-details
              />
            </v-flex>
            <v-flex :class="[fullForm ? 'py-1 xs12 sm6 md4 lg3' : 'py-1 xs12 md4']">
              <v-text-field
                v-model="cliente.Web"
                label="Web"
                class="mt-1"
                hide-details
              />
            </v-flex>
            <v-flex :class="[fullForm ? 'py-1 xs12 sm6 md4 lg3' : 'py-1 xs12 md4']">
              <v-text-field
                v-model="cliente.DiasAceptacionVistoBueno"
                label="Días de aceptación visto bueno"
                class="mt-1"
                hide-details
              />
            </v-flex>
            <v-flex :class="[fullForm ? 'py-1 xs12 sm6 md4 lg3' : 'py-1 xs12 md4']">
              <v-checkbox v-model="checkbox1" label="Bloquear" />
            </v-flex>
            <v-flex :class="[fullForm ? 'py-1 xs12 sm6 md4 lg3' : 'py-1 xs12 md4']">
              <v-date v-model="cliente.FechaBloqueo" label="Fecha de bloqueo" class="mt-3" :disabled="isDisabled" />
            </v-flex>
          </v-layout>
          <v-layout align-space-between justify-start row fill-height wrap>
            <v-flex :class="[fullForm ? 'py-1 xs12' :'py-1 xs12']">
              <v-textarea
                v-model="cliente.MotivoBloqueo"
                :disabled="isDisabled"
                :max-height="25"
                :hide-details="!fullForm"
                rows="2"
                label="Motivo Bloqueo"
                class="mt-0"
              />
            </v-flex>
          </v-layout>
          <v-menu
            open-on-hover
            top
            nudge-top="34"
            transition="fade-transition"
            content-class="elevation-0"
          >
            <template v-slot:activator="{ on }">
              <v-btn class="mt-3" color="success" v-on="on" @click="modify('exit')">
                <v-icon class="mr-2">
                  mdi-content-save
                </v-icon>Guardar
              </v-btn>
            </template>
            <v-list class="small-list success py-0" dark>
              <v-list-tile @click="modify()">
                Guardar sin salir
              </v-list-tile>
            </v-list>
          </v-menu>
        </v-container>
      </v-form>
    </v-card>
    <v-layout v-if="!isNew" row class="relative-position">
      <v-flex xs12>
        <v-card-title v-if="fullForm" class="py-2 blue">
          <div class="text-center width-100p">
            <div class="headline text-center">
              Instalaciones
            </div>
          </div>
        </v-card-title>
        <v-data-table v-model="instalaciones" :headers="columns" :items="instalaciones"
                      :pagination.sync="serverPagination" class="elevation-8"
        >
          <template v-slot:items="props">
            <tr :class="`theme--light cursor-pointer py-2`" class="pt-2">
              <td key="Nombre" @dblclick="loadInstalacion(props.item)">
                <div class="ellipsis">
                  {{ props.item.Nombre }}
                </div>
                <!--<router-link :to="loadInstalacion(props.item, true)" :event="null" tabindex="-1" />-->
              </td>
              <td key="Cif" @dblclick="loadInstalacion(props.item)">
                <div class="ellipsis">
                  {{ props.item.Cif }}
                </div>
                <!--<router-link :to="loadInstalacion(props.item, true)" :event="null" tabindex="-1" />-->
              </td>
              <td key="Poblacion" @dblclick="loadInstalacion(props.item)">
                <div class="ellipsis">
                  {{ props.item.Poblacion }}
                </div>
                <!--router-link :to="loadInstalacion(props.item, true)" :event="null" tabindex="-1" />-->
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-flex>
    </v-layout>
    <v-menu
      v-if="!isNew"
      open-on-hover
      top
      nudge-top="34"
      transition="fade-transition"
      content-class="elevation-0"
    >
      <template v-slot:activator="{ on }">
        <v-tab :to="{name: 'InstalacionEdit', params: { clienteProp: clienteProp, instalacionProp: 'new' }}" v-on="on">
          <v-btn class="mt-3" color="success" v-on="on" @click="createInstalacion()">
            <v-icon class="mr-2">
              mdi-plus-circle-outline
            </v-icon>Nueva Instalación
          </v-btn>
        </v-tab>
      </template>
    </v-menu>
  </v-container>
</template>

<script>
import VDate from '@/components/VDate'
import moment from 'moment'
import { Entities, Forms } from '@/mixins/index.js'

export default {
  name: 'ClientesEdit',
  components: { VDate },
  mixins: [Entities, Forms],
  props: {
    fullForm: { type: Boolean, default: true },
    clienteProp: { type: [String, Number], default: '0' }
  },
  data () {
    return {
      cliente: {},
      isNew: true,
      checkbox1: false,
      isDisabled: true,
      serverPagination: { initial: true,
        page: 1,
        rowsPerPage: 10,
        sortBy: 'Nombre',
        descending: true
      },
      total: 5,
      rowsPerPageOptions: [20, 50, 100, 150, 200],
      columns: [
        { text: 'Nombre', value: 'Nombre', sortable: true, align: 'left' },
        { text: 'Cif', value: 'Cif', sortable: true, align: 'left' },
        { text: 'Población', value: 'Poblacion', sortable: true, align: 'left' }
      ],
      instalaciones: []
    }
  },
  metaInfo () {
    return {
      title: (this.isNew ? `Nuevo Cliente` : `${this.cliente.Nombre}`)
    }
  },
  watch: {
    checkbox1 () {
      if (this.checkbox1 === true) { this.isDisabled = false } else { this.isDisabled = true }
    }
  },
  mounted () {
    this.loadCliente(this.clienteProp)
    this.obtenerInstalacion(this.clienteProp)
  },
  methods: {
    loadCliente (cliente) {
      if (cliente !== 'new') {
        this.axios
          .get(`${this.$apiUrl('clientes')}?id=${this.clienteProp}`,
            { headers: { 'Content-Type': 'application/json' } }
          )
          .then(({ data }) => {
            this.cliente = data
            this.isNew = false

            if (data.Estado === 'I') {
              this.checkbox1 = true
            } else {
              this.checkbox1 = false
            }
          })
      }
    },
    obtenerInstalacion (cliente) {
      if (cliente !== 'new') {
        this.axios
          .get(`${this.$apiUrl('instalacion')}?cliente=${cliente}`,
            { headers: { 'Content-Type': 'application/json' } }
          )
          .then(({ data }) => {
          // retorna las instalaciones del cliente seleccionado
            for (let z = 0; z < data.length; z++) {
              this.instalaciones.push(data[z])
            }
          })
      }
    },
    loadInstalacion (instalacion, getHref = false) {
      if (getHref) {
        let routeData = this.$router.resolve({ name: 'InstalacionEdit',
          params: { clienteProp: instalacion.Cliente, instalacionProp: instalacion.Instalacion }
        })
        return routeData.resolved.fullPath
      } else {
        this.$router.push({ name: 'InstalacionEdit',
          params: { clienteProp: instalacion.Cliente, instalacionProp: instalacion.Instalacion }
        })
      }
    },
    modify (postAction) {
      if (this.cliente.FechaBloqueo) {
        this.cliente.FechaBloqueo = moment(
          this.cliente.FechaBloqueo
        ).format('YYYY-MM-DD')
      }

      if (this.isNew) {
        this.cliente.Estado = 'A'
        this.axios
          .post(`${this.$apiUrl('clientes')}?cliente=${this.cliente.Nombre}`,
            this.cliente,
            { headers: { 'Content-Type': 'application/json' } }
          )
          .then(response => {
            if (response.status === 201) {
              this.$notify({ message: 'Cliente creado correctamente' })
              if (
                this.postAction({ action: postAction, toName: 'clientes' })
              ) {
                this.$router.push({
                  name: 'ClientesEdit',
                  params: {
                    clienteProp: response.data.Codigo
                  }
                })
              } else {
                this.loadCliente(response.data.Codigo)
              }
            }
          })
      } else {
        if (this.checkbox1 === true) {
          this.cliente.Estado = 'I'
        } else {
          this.cliente.Estado = 'A'
          this.cliente.FechaBloqueo = null
          this.cliente.MotivoBloqueo = null
        }
        this.axios
          .put(`${this.$apiUrl('clientes')}?id=${this.clienteProp}&cliente=${this.cliente.Nombre}`,
            this.cliente,
            { headers: { 'Content-Type': 'application/json' } }
          )
          .then(response => {
            if (response.status === 204) {
              this.$notify({ message: 'Cliente actualizado correctamente' })
            }
          })
      }
    },
    createInstalacion () {
      let routeData = this.$router.resolve({ name: 'InstalacionEdit',
        params: { clienteProp: this.clienteProp, instalacionProp: 'new' } })
      return routeData.resolved.fullPath
    }
  }
}
</script>
